import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { Markout } from 'shared/models/markout.model';
import { LuxonDatePipe } from 'shared/pipes/luxon-date.pipe';

@Component({
  selector: 'app-markout-preview-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, RouterLink, LuxonDatePipe],
  templateUrl: './markout-preview-dialog.component.html'
})
export class MarkoutPreviewDialogComponent {
  markout: Markout;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { markout: Markout },
    private dialogRef: MatDialogRef<MarkoutPreviewDialogComponent>
  ) {
    this.markout = data.markout;
  }
}
